import * as actions from "actions/types";

export default function(state = null, action) {
  switch (action.type) {
    case actions.FETCH_ADDRESSES:
      return { ...state, list: action.payload };
    default:
      return state;
  }
}
